var _g, _path, _path2, _path3, _path4, _g2, _g3, _g4, _g5, _g6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect, _rect2, _path24, _rect3, _rect4, _path25, _ellipse, _rect5, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 179,
    viewBox: "0 0 232 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19132_24679)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.387 8.34466L100.369 7.97894L100.311 7.59092L100.24 7.28764L100.164 7.06464L100.048 6.77474L99.9144 6.52052L99.6959 6.18156L99.4506 5.86936L99.2053 5.6196L98.9734 5.4189L98.7415 5.24942L98.4828 5.08886L98.2107 4.9506L97.9743 4.85248L97.7513 4.77666L97.4035 4.68746L97.1492 4.64732L96.9218 4.62502L96.6631 4.6161L96.4847 4.62056L96.2216 4.64286L95.9763 4.67854L95.7399 4.73206L95.5481 4.78558L95.4009 4.8391L95.2404 4.89708L95.0843 4.96844L94.9371 5.0398L94.8033 5.11116L94.616 5.23158L94.4286 5.36092L94.3171 5.45012L94.2324 5.51702L94.1254 5.61514L93.996 5.40552L93.7998 5.11562L93.6392 4.906L93.3895 4.6161L93.1352 4.36188L92.8989 4.14334L92.7026 3.9917L92.5019 3.84452L92.27 3.68842L91.9756 3.51448L91.7526 3.39852L91.4494 3.26472L91.1372 3.1443L90.7848 3.03726L90.4325 2.95698L90.1114 2.90346L89.8616 2.8767L89.5583 2.8544L89.3576 2.84994L88.9963 2.86332L88.7332 2.88562L88.4834 2.9213L88.2069 2.97036L87.8546 3.05956L87.6048 3.13538L87.306 3.24688L87.0562 3.35392L86.8377 3.46096L86.6459 3.56354L86.4229 3.69734L86.2356 3.82668L86.0572 3.95156L85.9457 4.04076L85.8743 4.09874L85.7851 4.1701L85.6915 4.25038L85.5844 4.06306L85.3124 3.63936L85.0359 3.26026L84.7772 2.93914L84.5319 2.66708L84.2598 2.3861L83.9922 2.13634L83.6488 1.84198L83.4436 1.68142L83.185 1.4941L82.953 1.338L82.7256 1.19528L82.507 1.06594L82.293 0.949981L81.9495 0.7805L81.6909 0.66454L81.4545 0.57088L81.1869 0.4683L80.839 0.3568L80.558 0.27652L80.2726 0.20516L79.9961 0.14718L79.6972 0.0981201L79.4118 0.05798L79.162 0.03122L78.8811 0.01338L78.6714 0H78.4172L78.1229 0.00446L77.8597 0.01784L77.5877 0.04014L77.3201 0.07136L77.0525 0.1115L76.7759 0.16056L76.5262 0.21408L76.272 0.27652L76.0044 0.35234L75.7457 0.43708L75.5316 0.5129L75.1882 0.6467L74.9117 0.771581L74.6842 0.878621L74.4746 0.990121L74.1713 1.1596L73.9884 1.2711L73.7476 1.4272L73.5469 1.56992L73.3239 1.73494L73.0875 1.92226L72.8734 2.10958L72.6237 2.3415L72.423 2.5422L72.2134 2.7652L71.9591 3.05956L71.7451 3.33608L71.5711 3.57692L71.3883 3.84452L71.2634 4.05414L71.0894 4.35742L70.9378 4.6384L70.804 4.92384L70.6791 5.2182L70.5765 5.49472L70.474 5.78908L70.3981 6.03884L70.3134 6.35996L70.2643 6.56958L70.2242 6.76136L70.1885 6.96652L70.1573 7.1583L70.135 7.35454L70.1038 7.65782L70.0859 7.92543V8.34466H71.0092H100.387Z",
    fill: "#080333"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M210.845 141.137C205.06 132.588 198.337 122.435 200.257 111.522C203.511 100.405 211.439 91.078 217.28 81.3333C224.178 69.0666 218.921 64.987 207.535 60.4901C203.622 59.0623 198.458 58.2742 194.638 56.6238C186.293 51.923 187.016 43.9399 175.111 38.6642C167.592 34.4641 160.48 35.7436 152.683 38.1543C146.211 39.8046 139.137 40.6113 132.47 40.4073C113.324 39.2483 93.89 38.2006 74.7066 38.4788C65.7314 38.7291 55.8476 38.8218 47.197 41.4643C35.2734 46.6936 25.7419 57.4026 24.6942 70.9951C23.7021 104.207 42.5147 110.669 38.1662 122.871C34.578 134.878 31.3051 158.41 43.2565 166.3C53.4184 170.797 74.9755 160.978 87.6223 161.025C99.9631 160.311 103.718 163.185 114.019 168.581C125.581 173.839 138.2 177 150.791 178.187C169.057 180.097 187.823 177.39 205.022 170.899C223.214 163.51 222.491 155.434 210.845 141.127V141.137Z",
    fill: "#080333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9827 147.989H178.732C184.647 147.989 190.59 148.174 196.506 147.989C196.589 147.989 196.673 147.989 196.756 147.989C198.546 147.989 198.546 145.207 196.756 145.207H68.0072C62.0918 145.207 56.1485 145.022 50.2331 145.207C50.1496 145.207 50.0662 145.207 49.9827 145.207C48.1933 145.207 48.1933 147.989 49.9827 147.989Z",
    fill: "#080333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.287 147.985H216.137C217.926 147.985 217.926 145.203 216.137 145.203H204.287C202.498 145.203 202.498 147.985 204.287 147.985Z",
    fill: "#080333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8109 147.985H42.6603C44.4497 147.985 44.4497 145.203 42.6603 145.203H30.8109C29.0214 145.203 29.0214 147.985 30.8109 147.985Z",
    fill: "#080333"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19132_24679)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M224.09 33.375L223.163 39.8376L217.508 40.995L223.504 42.2875L225.017 48.21L225.963 41.9982L231.354 40.7828L225.812 39.8954L224.09 33.375Z",
    fill: "#7292FE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_19132_24679)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M223.161 110.336L222.234 116.799L216.578 117.956L222.574 119.248L224.087 125.171L225.033 118.959L230.424 117.744L224.882 116.856L223.161 110.336Z",
    fill: "#7292FE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_19132_24679)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.22313 49.1406L6.29628 55.6032L0.640625 56.7607L6.63676 58.0532L8.14998 63.9756L9.09574 57.7638L14.4866 56.5485L8.94442 55.6611L7.22313 49.1406Z",
    fill: "#7292FE"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_19132_24679)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.22313 127.953L6.29628 134.416L0.640625 135.573L6.63676 136.866L8.14998 142.788L9.09574 136.576L14.4866 135.361L8.94442 134.474L7.22313 127.953Z",
    fill: "#7292FE"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_19132_24679)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M17.8381 87.1562L17.3747 90.3875L14.5469 90.9663L17.5449 91.6125L18.3016 94.5737L18.7744 91.4678L21.4699 90.8602L18.6988 90.4165L17.8381 87.1562Z",
    fill: "#7292FE"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5644 47H118.641C120.85 47 122.641 48.7909 122.641 51V66C122.641 68.2091 120.85 70 118.641 70H85.5644C84.5528 70 83.5788 69.6167 82.8385 68.9273L74.7843 61.4273C73.0855 59.8455 73.0855 57.1545 74.7843 55.5727L82.8385 48.0727C83.5788 47.3833 84.5528 47 85.5644 47Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63L87 59L91 55",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 59L107.5 59",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M118 47H83L74.5 56H118V47Z",
    fill: "#080333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.497 61H126.641C124.431 61 122.641 62.7909 122.641 65V80C122.641 82.2091 124.431 84 126.641 84H160.497C161.495 84 162.457 83.6268 163.194 82.9536L171.407 75.4536C173.143 73.8675 173.143 71.1325 171.407 69.5464L163.194 62.0464C162.457 61.3732 161.495 61 160.497 61Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.5 69L157.5 73L153.5 77",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157 73H137",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M162 61H128V70H172L162 61Z",
    fill: "#080333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1262 78H118.641C120.85 78 122.641 79.7909 122.641 82V90C122.641 92.2091 120.85 94 118.641 94H96.1262C95.1434 94 94.1951 93.6382 93.4621 92.9837L88.9822 88.9837C87.2011 87.3933 87.2011 84.6067 88.9822 83.0163L93.4621 79.0163C94.1951 78.3618 95.1434 78 96.1262 78Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100 89L97 86L100 83",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.375 86L112.375 86",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M118 78H95L87.5 85H118V78Z",
    fill: "#080333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.641 40C118.641 37.7909 120.431 36 122.641 36H123.641C125.85 36 127.641 37.7909 127.641 40V146H118.641V40Z",
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M128 37H119V46H128V37Z",
    fill: "#080333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.877 128.091C109.46 126.629 104.915 116.022 103.071 110.902C103.592 116.377 106.79 129.722 115.409 139.303C113.52 139.313 108.345 137.331 105.546 132.533C106.637 137.194 111.383 147.218 118.837 146.806C121.567 146.405 126.87 138.709 124.957 127.332L124.957 127.332C124.804 128.53 123.769 136.666 120.692 137.887C123.385 132.41 119.783 115.672 118.168 110.82C118.794 117.39 117.399 125.558 116.282 126.683C116.669 124.598 108.038 97.6808 106.715 98.0354C105.656 98.3191 110.382 118.191 112.877 128.091Z",
    fill: "#90079E",
    stroke: "#080333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.695 132.349C125.08 130.194 126.071 121.894 126.768 118.014C125.113 121.637 122.285 131.167 124.222 140.299C123.034 139.622 120.505 136.504 120.487 132.48C119.483 135.799 118.83 143.806 123.655 146.248C125.513 146.985 131.627 144.078 134.548 136.247L134.547 136.247C134.018 136.944 130.422 141.673 128.05 141.325C131.723 138.864 135.525 127.059 136.269 123.43C134.282 127.779 130.449 132.398 129.341 132.699C130.339 131.531 134.673 111.519 133.715 111.262C132.948 111.057 128.715 125.234 126.695 132.349Z",
    fill: "#90079E",
    stroke: "#080333",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M178.684 114.961H163.404C162.789 114.961 162.32 115.509 162.416 116.116L164.87 131.751C164.946 132.238 165.365 132.596 165.858 132.596H177.036C177.548 132.596 177.977 132.21 178.031 131.701L179.679 116.066C179.741 115.475 179.278 114.961 178.684 114.961Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M164.188 132.523L177.846 132.523",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M151.17 110.977L148.69 135.318C148.63 135.908 149.093 136.42 149.685 136.42H164.057C164.649 136.42 165.111 135.908 165.051 135.318L162.572 110.977C162.52 110.466 162.09 110.078 161.577 110.078H152.164C151.651 110.078 151.222 110.466 151.17 110.977Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 146.625,
    y: 136.422,
    width: 20.4879,
    height: 8.78053,
    rx: 1,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 153.453,
    y: 105.203,
    width: 6.8293,
    height: 4.87807,
    rx: 1,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M180.435 110.977L177.956 135.318C177.896 135.908 178.358 136.42 178.951 136.42H193.322C193.915 136.42 194.377 135.908 194.317 135.318L191.838 110.977C191.786 110.466 191.356 110.078 190.843 110.078H181.43C180.917 110.078 180.487 110.466 180.435 110.977Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 174.922,
    y: 136.422,
    width: 21.4635,
    height: 8.78053,
    rx: 1,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 182.727,
    y: 105.203,
    width: 6.8293,
    height: 4.87807,
    rx: 1,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.093 114.957C168.54 114.957 168.081 114.504 168.205 113.965C168.244 113.795 168.293 113.627 168.353 113.464C168.524 112.99 168.776 112.56 169.093 112.197C169.41 111.835 169.786 111.548 170.2 111.352C170.615 111.155 171.059 111.054 171.507 111.054C171.956 111.054 172.4 111.155 172.814 111.352C173.228 111.548 173.605 111.835 173.922 112.197C174.239 112.56 174.49 112.99 174.662 113.464C174.721 113.627 174.771 113.795 174.81 113.965C174.934 114.504 174.474 114.957 173.922 114.957L171.507 114.957L169.093 114.957Z",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.72,
    cy: 123.739,
    rx: 2.43903,
    ry: 2.92684,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 160.281,
    y: 120.812,
    width: 22.4391,
    height: 5.85369,
    rx: 1,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M180.77 121.789H162.233C161.695 121.789 161.258 122.226 161.258 122.765C161.258 123.303 161.695 123.74 162.233 123.74H180.77C181.309 123.74 181.746 123.303 181.746 122.765C181.746 122.226 181.309 121.789 180.77 121.789Z",
    fill: "#080333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M161.621 111.055H151.578V114.957H161.621V111.055Z",
    fill: "#080333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M191.16 111.055H181.117V114.957H191.16V111.055Z",
    fill: "#080333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M165.57 137.5H147.625C147.073 137.5 146.625 137.948 146.625 138.5V139.952C146.625 140.504 147.073 140.952 147.625 140.952H165.57C166.123 140.952 166.57 140.504 166.57 139.952V138.5C166.57 137.948 166.123 137.5 165.57 137.5Z",
    fill: "#080333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M194.625 137.359H176.68C176.127 137.359 175.68 137.807 175.68 138.359V139.811C175.68 140.364 176.127 140.811 176.68 140.811H194.625C195.177 140.811 195.625 140.364 195.625 139.811V138.359C195.625 137.807 195.177 137.359 194.625 137.359Z",
    fill: "#080333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5079 112.178L88.8328 111.166C91.3424 110.578 93.7443 112.483 93.7443 115.06V140.188C93.7443 142.046 92.4649 143.659 90.6558 144.082L84.5079 145.521C83.974 145.646 83.4202 145.66 82.8808 145.562L68.1393 142.882C67.5478 142.774 66.9397 142.801 66.3601 142.961L59.9075 144.741C57.3603 145.444 54.8438 143.528 54.8438 140.885V115.841C54.8438 114.041 56.0454 112.463 57.78 111.985L66.3601 109.618C66.9397 109.458 67.5478 109.431 68.1393 109.538L82.8808 112.219C83.4202 112.317 83.974 112.303 84.5079 112.178Z",
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3442 129.296L72.9891 111.651L72.6136 110.149L67.3577 109.398L59.8493 111.276L56.095 112.402L54.9688 114.279L55.3442 129.296Z",
    fill: "#90079E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6172 127.975L72.3575 110.234L75.5636 111.089L74.6981 111.934L56.3165 130.315L55.0447 131.822L54.6172 127.975Z",
    fill: "#080333"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1172 128.919L92.885 124.414V142.81L92.1341 143.561L91.0079 144.312L83.124 146.189L77.1172 145.062V128.919Z",
    fill: "#90079E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7663 128.93V143.947L67.3807 142.445L58.746 145.073H57.2443L56.118 144.322L55.3672 142.82V135.312L76.7663 128.93Z",
    fill: "#795AF7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5079 112.178L88.8328 111.166C91.3424 110.578 93.7443 112.483 93.7443 115.06V140.188C93.7443 142.046 92.4649 143.659 90.6558 144.082L84.5079 145.521C83.974 145.646 83.4202 145.66 82.8808 145.562L68.1393 142.882C67.5478 142.774 66.9397 142.801 66.3601 142.961L59.9075 144.741C57.3603 145.444 54.8438 143.528 54.8438 140.885V115.841C54.8438 114.041 56.0454 112.463 57.78 111.985L66.3601 109.618C66.9397 109.458 67.5478 109.431 68.1393 109.538L82.8808 112.219C83.4202 112.317 83.974 112.303 84.5079 112.178Z",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2089 130.825L55.4959 137.312L54.6016 134.457L93.5021 122.273L94.3964 125.129L79.2013 129.888V144.22H76.2089V130.825Z",
    fill: "#080333"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.7301 96.8125C76.382 96.8123 68.8083 100.216 73.3117 110.589C75.3793 115.352 77.0042 118.683 78.2066 120.954C79.3948 123.199 82.0018 123.16 83.143 120.891C84.2846 118.621 85.8459 115.307 87.8943 110.589C92.3977 100.216 85.0782 96.8123 80.7301 96.8125ZM80.6291 109.08C82.6076 109.08 84.2114 107.476 84.2114 105.498C84.2114 103.519 82.6076 101.915 80.6291 101.915C78.6507 101.915 77.0469 103.519 77.0469 105.498C77.0469 107.476 78.6507 109.08 80.6291 109.08Z",
    fill: "#795AF7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3117 110.589L74.6876 109.992L73.3117 110.589ZM80.7301 96.8125L80.7301 98.3125H80.7302L80.7301 96.8125ZM78.2066 120.954L79.5323 120.253L78.2066 120.954ZM83.143 120.891L84.483 121.565V121.565L83.143 120.891ZM87.8943 110.589L86.5184 109.992L87.8943 110.589ZM74.6876 109.992C72.5941 105.17 73.445 102.386 74.8318 100.797C76.3407 99.068 78.8501 98.3124 80.7301 98.3125L80.7302 95.3125C78.262 95.3124 74.8106 96.2587 72.5714 98.8247C70.2102 101.531 69.5259 105.636 71.9358 111.187L74.6876 109.992ZM79.5323 120.253C78.3515 118.022 76.7431 114.726 74.6876 109.992L71.9358 111.187C74.0154 115.977 75.6569 119.344 76.8809 121.656L79.5323 120.253ZM81.8029 120.217C81.4431 120.932 80.9704 121.111 80.672 121.115C80.3761 121.119 79.9048 120.956 79.5323 120.253L76.8809 121.656C77.6965 123.197 79.1228 124.137 80.7128 124.115C82.3003 124.093 83.7017 123.118 84.483 121.565L81.8029 120.217ZM86.5184 109.992C84.4781 114.691 82.9288 117.978 81.8029 120.217L84.483 121.565C85.6405 119.264 87.2137 115.924 89.2702 111.187L86.5184 109.992ZM80.7302 98.3125C82.6066 98.3124 85.0409 99.0651 86.4847 100.778C87.8178 102.359 88.6204 105.15 86.5184 109.992L89.2702 111.187C91.6717 105.655 91.0662 101.558 88.7784 98.8441C86.6013 96.2616 83.2017 95.3124 80.7301 95.3125L80.7302 98.3125ZM82.7114 105.498C82.7114 106.648 81.7792 107.58 80.6291 107.58V110.58C83.436 110.58 85.7114 108.304 85.7114 105.498H82.7114ZM80.6291 103.415C81.7792 103.415 82.7114 104.348 82.7114 105.498H85.7114C85.7114 102.691 83.436 100.415 80.6291 100.415V103.415ZM78.5469 105.498C78.5469 104.348 79.4791 103.415 80.6291 103.415V100.415C77.8223 100.415 75.5469 102.691 75.5469 105.498H78.5469ZM80.6291 107.58C79.4791 107.58 78.5469 106.648 78.5469 105.498H75.5469C75.5469 108.304 77.8223 110.58 80.6291 110.58V107.58Z",
    fill: "#080333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19132_24679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.3013,
    height: 8.34466,
    fill: "white",
    transform: "translate(70.0859)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19132_24679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 14.835,
    fill: "white",
    transform: "translate(217.508 33.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_19132_24679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 14.835,
    fill: "white",
    transform: "translate(216.578 110.336)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_19132_24679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 14.835,
    fill: "white",
    transform: "translate(0.640625 49.1406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_19132_24679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.846,
    height: 14.835,
    fill: "white",
    transform: "translate(0.640625 127.953)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_19132_24679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.92298,
    height: 7.41748,
    fill: "white",
    transform: "translate(14.5469 87.1562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadSign);
export default __webpack_public_path__ + "static/media/road-sign.e22adea042ee55dcf5d4abd9365520a9.svg";
export { ForwardRef as ReactComponent };